import { EApplicationType } from '@/interfaces'
import { ApplicationsState, ConvocatoriasState } from '@/state'
import { applicationsStateActions } from '@/state/actions'
import { Button, Row, Tooltip } from 'antd'
import { FaTools } from 'react-icons/fa'
import { FaCheck, FaCity } from 'react-icons/fa6'
import { GiFruitTree } from 'react-icons/gi'

export default function ImportTypeChooser() {
  const handleChooseType = (appType: EApplicationType) => {
    applicationsStateActions.setImportApplicationType(appType)
  }

  const currentImportType = ApplicationsState.importApplicationType.value

  return (
    <Row className='import-type-chooser'>
      <div className='chooser-title'>TIPO DE SOLICITUD</div>

      <div className='chooser-options'>
        {ConvocatoriasState.currentConvocatoria.value.appType?.includes(
          EApplicationType.URBAN_LIVING
        ) && (
          <Tooltip title='Vivienda Urbana' placement='bottom'>
            <div className='chooser-option'>
              <Button
                shape='circle'
                icon={<FaCity />}
                onClick={() => handleChooseType(EApplicationType.URBAN_LIVING)}
              />
              {currentImportType === EApplicationType.URBAN_LIVING && (
                <div className='selected'>
                  <FaCheck />
                </div>
              )}
            </div>
          </Tooltip>
        )}
        {ConvocatoriasState.currentConvocatoria.value.appType?.includes(
          EApplicationType.RURAL_LIVING
        ) && (
          <Tooltip title='Vivienda Rural' placement='bottom'>
            <div className='chooser-option'>
              <Button
                shape='circle'
                icon={<GiFruitTree />}
                onClick={() => handleChooseType(EApplicationType.RURAL_LIVING)}
              />
              {currentImportType === EApplicationType.RURAL_LIVING && (
                <div className='selected'>
                  <FaCheck />
                </div>
              )}
            </div>
          </Tooltip>
        )}
        {ConvocatoriasState.currentConvocatoria.value.appType?.includes(
          EApplicationType.IMPROVEMENT
        ) && (
          <Tooltip title='Mejora de vivienda' placement='bottom'>
            <div className='chooser-option'>
              <Button
                shape='circle'
                icon={<FaTools />}
                onClick={() => handleChooseType(EApplicationType.IMPROVEMENT)}
              />
              {currentImportType === EApplicationType.IMPROVEMENT && (
                <div className='selected'>
                  <FaCheck />
                </div>
              )}
            </div>
          </Tooltip>
        )}
      </div>
    </Row>
  )
}
